"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableCard = void 0;
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const Button_1 = __importDefault(require("../../Button/Button"));
const FeatureIcon_1 = __importDefault(require("../../FeatureIcon/FeatureIcon"));
const Icon_1 = __importDefault(require("../../Icon/Icon"));
const ExpandableCard = (props) => {
    const initialOpenState = typeof props.openByDefault === 'undefined' ? false : props.openByDefault;
    const [open, setOpen] = React.useState(initialOpenState);
    const toggleOpen = () => setOpen(!open);
    const className = classnames_1.default({
        'expandable-card': true,
        'expandable-card-regular': true,
        [`expandable-card-${props.color || 'grey'}`]: true,
    });
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "header", onClick: toggleOpen },
            React.createElement("div", { className: "header-inner" },
                props.icon &&
                    React.createElement(FeatureIcon_1.default, { icon: props.icon, color: "blue" }),
                props.logoUrl &&
                    React.createElement("img", { className: "feature-icon", src: props.logoUrl }),
                renderHeading()),
            React.createElement("button", { onClick: toggleOpen, className: "toggle-icon", type: "button" },
                React.createElement(Icon_1.default, { icon: open ? 'arrow_up' : 'arrow_down' }))),
        renderBody()));
    function renderHeading() {
        if (typeof props.title === 'string') {
            return React.createElement("h2", null, props.title);
        }
        return (React.createElement("div", null,
            React.createElement("p", null, props.title.top),
            React.createElement("h3", null, props.title.bottom)));
    }
    function renderBody() {
        if (!open) {
            return null;
        }
        return (React.createElement("div", { className: "expandable-card-body" },
            props.children,
            props.actions &&
                React.createElement("div", { className: "buttons" }, props.actions.map((action) => (React.createElement(Button_1.default, { onClick: action.action, key: action.label, color: "secondary" }, action.label))))));
    }
};
exports.ExpandableCard = ExpandableCard;
//# sourceMappingURL=ExpandableCard.js.map